module.exports = "/assets/images/0f8810546fbd8d78521929ba94b6029e.svg";